import React, { Component, useEffect, useState } from "react"
// import { Flipper } from "react-flip-toolkit"
// import DropdownContainer from "./DropdownContainer"
// import { Icon, DropdownSection, Heading } from "./DropdownContents/Components.js"
import { BiCategoryAlt, BiChevronLeft, BiChevronRight } from "react-icons/bi";
import * as rsuite from 'rsuite'
import styled from "styled-components"
import * as General from '../Business/General/General.js'
import * as BiIcon from "react-icons/bi"
import { useNavigate, useLocation } from 'react-router-dom'
import { trackPromise } from 'react-promise-tracker';

import axios from 'axios';


// import InputMask from "react-input-mask";




const UserProperty = (props) => {
    const navigate = useNavigate();
    const toaster = rsuite.useToaster();
    const [open, setopen] = React.useState(false);
    const [InterMobileNo, setInterMobileNo] = React.useState(true);
    const [InterActiveCode, setInterActiveCode] = React.useState(false);
    const [Mobile, setMobile] = React.useState("");
    const [ActiveCode, setActiveCode] = React.useState("");
    const [UserDate, setUserDate] = React.useState("");
    const [Min, setMin] = React.useState(0);
    const [Sec, setSec] = React.useState(0);

    let MyInterval = null;
    var distance = 120000;

    const location = useLocation();

    const ShowPeroPerty = () => {

        console.log(location.pathname);
        localStorage.setItem("FarmBackPageFromLoging" , location.pathname)
        localStorage.setItem("FarmBackPageTitle" , document.title)

        window.location.href = "/UserLogin";

    }

    const GetActiveCode = () => {
        if (Mobile == "" || Mobile.length != 11 || Mobile.substring(0, 2) != "09") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("شماره همراه را به درستی وارد کنید")), 'topCenter')
        }
        else {
            var RequestOptions = {
                data: {
                    "Mobile": Mobile,
                    // "Count": Count,
                    // "Title": Title
                },
                url: General.ApiRoute() + "/Online_Customer/GetActiveCode",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {

                        if (result.data.includes("OK")) {
                            setInterActiveCode(true);
                            setInterMobileNo(false)
                            setUserDate(result.data)
                            Bind_Timer();
                            MyInterval = null;
                            distance = 120000;

                            // toaster.push(General.ShowMessage('success', General.SuccessMessage(Id.split("|")[1] +  " با موفقیت به سبد خرید شما اضافه شد . ")), 'topCenter')
                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')
                        }

                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                    })
            )

        }
    }

    const CheckActiveCode = () => {
        if (UserDate.split("|")[3] == ActiveCode.toString()) {
            localStorage.setItem("UserFullNameFarmAsan", UserDate.split("|")[1])
            localStorage.setItem("CustomerFarmAsanId", UserDate.split("|")[2])
            localStorage.setItem("IsSupplierFarmAsanId", 1)
            // localStorage.setItem("IsSupplierFarmAsanId", UserDate.split("|")[4])
            setInterMobileNo(false);
            setInterActiveCode(false);
        }
        else {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("کد فعال سازی اشتباه می باشد")), 'topCenter')
        }
    }



    const Bind_Timer = () => {

        MyInterval = setInterval(function () {

            distance = distance - 1000;
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            console.dir("minutes" + minutes)
            console.dir("seconds" + seconds)
            if (distance <= 0 || (minutes == 0 && seconds == 0)) {
                clearInterval(MyInterval)
                setSec(0);
                setMin(0);
            }

            else {

                if (minutes > 0) {
                    setMin(minutes.toString())
                }
                else {

                    setMin((0).toString());
                }

                if (seconds > 0) {
                    setSec(seconds.toString())
                }
                else {
                    setSec((0).toString());
                }
            }

        }, 1000)
    }


    // const ShowFactorHistory = () => {
    //     window.location.href = "/FactorHistory";

    // }
    // const ShowBuyFactorHistory = () => {
    //     window.location.href = "/BuyFactorHistory";

    // }



    useEffect(() => {
    }, []);





    return (
        // <>
        <b className="Cursor" onClick={() => ShowPeroPerty()}  >
            {localStorage.getItem("UserFullNameFarmAsan") == null || localStorage.getItem("UserFullNameFarmAsan") == "" ? "" : localStorage.getItem("UserFullNameFarmAsan")}
            <BiIcon.BiFace className="fw-bold Font25  m-2" />


        </b>

        //      <rsuite.Drawer size="full" placement="top" open={open} onClose={() => setopen(false)}>
        //         <rsuite.Drawer.Header>
        //             <rsuite.Drawer.Title className=" Font13">
        //                 {localStorage.getItem("UserFullNameFarmAsan") == null ? "" : localStorage.getItem("UserFullNameFarmAsan")}

        //             </rsuite.Drawer.Title>
        //             <rsuite.Drawer.Actions>
        //                 <img className="Cursor" src="../../../../../../assets/images/Logo.png" style={{ width: 30, height: 30, marginTop: 8 }} />
        //             </rsuite.Drawer.Actions>
        //         </rsuite.Drawer.Header>
        //         <rsuite.Drawer.Body style={{ "background-color": "#2f4858" }} className="White_Text text-center">
        //             {localStorage.getItem("CustomerFarmAsanId") == null ?
        //                 <>
        //                     <rsuite.Row className={InterMobileNo ? "" : "hide"}>
        //                         <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>
        //                         <rsuite.Col xs={24} md={12} className="mt-5 pt-5 text-center Font17">
        //                             <b>شماره همراه خود را وارد نمایید  </b>
        //                             <rsuite.Input type="number" maxLength={11} className="p-3 m-3 border" placeholder="09xxxxxxxxx" value={Mobile} onChange={(e) => setMobile(e)} ></rsuite.Input>
        //                         </rsuite.Col>
        //                         <rsuite.Col xsHidden xlHidden md={6}></rsuite.Col>
        //                     </rsuite.Row>
        //                     <rsuite.Row className={InterMobileNo ? "" : "hide"}>
        //                         <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>

        //                         <rsuite.Col xs={12} md={6} className="p-2">
        //                             <rsuite.Button color="red" onClick={() => GetActiveCode()} className="border border-2 me-3 ml-3 p-4 Font17" size="lg" style={{ color: "#ffff" }} block appearance="subtle">
        //                                 دریافت کد فعال سازی
        //                             </rsuite.Button>
        //                         </rsuite.Col>
        //                         <rsuite.Col xs={12} md={6} className="p-2">
        //                             <rsuite.Button color="red" className="border border-2 me-3 ml-3  p-4 Font17" size="lg" style={{ color: "#ffff" }} block appearance="subtle">
        //                                 حساب کاربری ندارم !
        //                             </rsuite.Button>
        //                         </rsuite.Col>

        //                         <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>


        //                     </rsuite.Row>
        //                     <rsuite.Row className={InterActiveCode ? "" : "hide"}>
        //                         <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>
        //                         <rsuite.Col xs={24} md={12} className="mt-5 pt-5 text-center Font17">
        //                             <b>کد فعال سازی را وارد کنید</b>
        //                             <rsuite.Input type="number" maxLength={5} className="p-3 m-3 border" placeholder="XXXXX" value={ActiveCode} onChange={(e) => setActiveCode(e)} ></rsuite.Input>
        //                         </rsuite.Col>
        //                         <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>
        //                     </rsuite.Row>
        //                     <rsuite.Row className={InterActiveCode ? "" : "hide"}>
        //                         <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>

        //                         <rsuite.Col xs={12} md={6} className="p-2">
        //                             <rsuite.Button color="red" onClick={() => CheckActiveCode()} className="border border-2 me-3 ml-3 p-4 Font17" size="lg" style={{ color: "#ffff" }} block appearance="subtle">
        //                                 صحت سنجی کد فعال سازی
        //                             </rsuite.Button>
        //                         </rsuite.Col>
        //                         <rsuite.Col xs={12} md={6} className="p-2">
        //                             <rsuite.Button disabled={Sec == 0 && Min == 0 ? false : true} color="red" onClick={() => GetActiveCode()} className="border border-2 me-3 ml-3  p-4 Font17" size="lg" style={{ color: "#ffff" }} block appearance="subtle">
        //                                 {Sec == 0 && Min == 0 ?
        //                                     <>
        //                                         ارسال مجدد کد!

        //                                     </>
        //                                     :
        //                                     <>
        //                                         {Sec} : {Min}

        //                                     </>
        //                                 }
        //                             </rsuite.Button>
        //                         </rsuite.Col>

        //                         <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>


        //                     </rsuite.Row>

        //                 </>
        //                 :
        //                 <rsuite.Row>

        //                     <rsuite.Col xs={24}>
        //                         <rsuite.Heading level={2} >
        //                             ارتباط با ما
        //                         </rsuite.Heading>
        //                         <p className="mt-4 Font17">
        //                             علت ارتباط با فارم آسان را انتخاب کنید
        //                         </p>
        //                     </rsuite.Col>
        //                     <rsuite.Col xs={24} md={localStorage.getItem("IsSupplierFarmAsanId") == "0" ? 8 : 6} className="p-2">
        //                         <rsuite.Button color="red" className="border border-2  p-4 Font17" size="lg" style={{ color: "#ffff" }} block appearance="subtle">
        //                             خدمات پس از فروش
        //                         </rsuite.Button>
        //                     </rsuite.Col>
        //                     <rsuite.Col xs={24} md={localStorage.getItem("IsSupplierFarmAsanId") == "0" ? 8 : 6} className="p-2">
        //                         <rsuite.Button color="red" className="border border-2  p-4 Font17" onClick={() => ShowFactorHistory()} size="lg" style={{ color: "#ffff" }} block appearance="subtle">
        //                             سابقه خرید کالا
        //                         </rsuite.Button>
        //                     </rsuite.Col>
        //                     {localStorage.getItem("IsSupplierFarmAsanId") == 1 || localStorage.getItem("IsSupplierFarmAsanId") == "1" ?
        //                         <rsuite.Col
        //                             xs={24} md={6} className="p-2">
        //                             <rsuite.Button color="red" className="border border-2  p-4 Font17" onClick={() => ShowBuyFactorHistory()} size="lg" style={{ color: "#ffff" }} block appearance="subtle">
        //                                 سابقه فروش کالا
        //                             </rsuite.Button>
        //                         </rsuite.Col>
        //                         :
        //                         <></>
        //                     }
        //                     <rsuite.Col xs={24} md={localStorage.getItem("IsSupplierFarmAsanId") == "0" ? 8 : 6} className="p-2">
        //                         <rsuite.Button color="red" className="border border-2  p-4 Font17" size="lg" style={{ color: "#ffff" }} block appearance="subtle">
        //                             پیگیری سفارش
        //                         </rsuite.Button>
        //                     </rsuite.Col>
        //                 </rsuite.Row>
        //             }

        //         </rsuite.Drawer.Body>
        //     </rsuite.Drawer >
        // </> 

    )

}

export default UserProperty;



